import { withDefault } from "@faedev/editor-utils";
import React, { ReactNode } from "react";
import { sMqGteTablet } from "src/styles/sMqGteTablet.module.scss";
import { CSSDisplay } from "src/types/CSSDisplay";

type Props = { display?: CSSDisplay | null | undefined; children?: ReactNode };

function MqGteTablet({ display, children }: Props) {
  return (
    <div
      style={
        {
          "--v-default-display": withDefault(display, `block`),
        } as React.CSSProperties
      }
      className={sMqGteTablet}
    >
      {children}
    </div>
  );
}

export default MqGteTablet;
